module.exports = __webpack_public_path__ + "static/media/a1.31b83b81.jpg";